import {
  addArchivoAtPath,
  getNodeAtPath,
  insertNodeWithArchivoAtParent,
  pathIndicesFromKey,
} from "../../../../utils/temarioTree";

export function getDocAddValidationMessage({
  selectedFile,
  bloqueSeleccionado,
  tipoInsert,
  rutaDestinoKey,
  listaActual,
  subseccionTrim,
}) {
  if (!selectedFile) {
    return "⚠️ Selecciona un archivo.";
  }
  if (!bloqueSeleccionado) {
    return "⚠️ Selecciona una pestaña.";
  }
  if (tipoInsert === "existente") {
    const path = pathIndicesFromKey(rutaDestinoKey);
    if (path.length === 0) {
      return "⚠️ Selecciona el nodo del temario donde añadir el archivo.";
    }
    const existente = getNodeAtPath(listaActual, path);
    if (!existente) {
      return "⚠️ El nodo elegido no existe. Elige otro o crea la estructura antes.";
    }
    const fileName = selectedFile.name || "";
    if (existente.archivos?.some((a) => a && a.nombre === fileName)) {
      return "⚠️ Ya existe un archivo con ese nombre en ese nodo.";
    }
    return null;
  }
  if (!subseccionTrim) {
    return "⚠️ Indica el nombre del nuevo nodo (tema, unidad o bloque).";
  }
  return null;
}

export function mergeArchivoIntoBloqueLista({
  tipoInsert,
  rutaDestinoKey,
  rutaPadreKey,
  subseccionTrim,
  posicion,
  lista,
  archivo,
}) {
  if (tipoInsert === "existente") {
    const path = pathIndicesFromKey(rutaDestinoKey);
    return addArchivoAtPath(lista, path, archivo, posicion);
  }
  const parentPath = pathIndicesFromKey(rutaPadreKey);
  return insertNodeWithArchivoAtParent(lista, parentPath, subseccionTrim, archivo, posicion);
}

export function docAddFailureMessage(tipoInsert) {
  if (tipoInsert === "existente") {
    return "⚠️ No se pudo añadir el archivo (¿nombre duplicado en el nodo?).";
  }
  return "⚠️ No se pudo crear el nodo o el archivo está duplicado.";
}
